import { Tabs } from "@shared/ui/tabs";
import { OverviewCards } from "./OverviewCards";
import DataHistory from "../data-history/DataHistory";
import SavedTemplates from "../data-saved/SavedTemplates";
import { useMemo } from "react";
import {
  ArrowLeft,
  File,
  Zap,
  Upload,
  History,
  BookmarkCheck,
} from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";

const DataMigrationLanding = () => {
  const tabComponents = useMemo(
    () => ({
      upload: {
        label: "Upload Data",
        icon: <Upload className="w-4 h-4" />,
        component: <OverviewCards key="overview-cards" />,
        className: "flex-1",
      },
      history: {
        label: "Migration History",
        icon: <History className="w-4 h-4" />,
        component: <DataHistory key="data-history" />, // Add key
        className: "flex-1",
      },
      templates: {
        label: "Saved Templates",
        icon: <BookmarkCheck className="w-4 h-4" />,
        component: <SavedTemplates key="saved-templates" />,
        className: "flex-1",
      },
    }),
    []
  );
  return (
    <div className="flex flex-col gap-5">
      <div>
        <PageHeader
          title="AI-Powered Data Upload"
          subtitle="Upload your data and let AI help you integrate it seamlessly into your system."
        />
      </div>

      <Tabs
        defaultValue="upload"
        className="w-full mt-4"
        tabsListClassName="bg-muted w-full flex justify-start rounded-lg mb-6"
        tabComponents={tabComponents}
      />
    </div>
  );
};

export default DataMigrationLanding;
